exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".insight-preview-float{position:fixed;top:12px;left:240px;width:920px;max-height:calc(100vh - 24px);overflow:visible;background:#fff;border-radius:8px;box-shadow:0 12px 40px rgba(15,23,42,.16);padding:16px 18px 8px;z-index:4000}.insight-preview-arrow{position:absolute;left:-8px;width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:8px solid #fff;filter:drop-shadow(-1px 0 1px rgba(15,23,42,.12));pointer-events:none}.insight-preview-arrow.is-right{left:auto;right:-8px;border-right:0;border-left:8px solid #fff;filter:drop-shadow(1px 0 1px rgba(15,23,42,.12))}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73185cc0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/customer/high-value.vue
// module id = 2214
// module chunks = 0